import { render, staticRenderFns } from "./LangBox.vue?vue&type=template&id=e23b22d2&scoped=true"
import script from "./LangBox.vue?vue&type=script&lang=js"
export * from "./LangBox.vue?vue&type=script&lang=js"
import style0 from "./LangBox.vue?vue&type=style&index=0&id=e23b22d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e23b22d2",
  null
  
)

export default component.exports